import { messages } from 'languages'
import { replace } from 'connected-react-router'
import keyMirror from 'pkeymirror'
import callAPI from 'utils/callAPI'
import { getCurrentLanguage, setHtmlLangAndDir } from 'utils'
import UAParser from 'ua-parser-js'
import sha256 from 'sha256'
import { Toast } from 'antd-mobile'
import { apiMiddleware } from 'redux-api-middleware'

// ------------------------------------
// Constants
// ------------------------------------
export const SITE_CONFIG = keyMirror({
  LANGUAGE_CHANGE: null,
  GET_SALT_REQUEST: null,
  GET_SALT_SUCCESS: null,
  REMOVE_SALT: null,
  QUERY_IAPCONFIG_REQUEST: null,
  QUERY_IAPCONFIG_SUCCESS: null,
  QUERY_AGREEMENTS_REQUEST: null,
  QUERY_AGREEMENTS_SUCCESS: null,
  QUERY_NOTICE_REQUEST: null,
  QUERY_NOTICE_SUCCESS: null,
  SAVE_SALT_KEY: null,
  GET_CAPTCHA_REQUEST: null,
  GET_CAPTCHA_SUCCESS: null,
  DEFAULT_REQUEST: null,
  DEFAULT_SUCCESS: null,
  GET_ALLOWED_COUNTRIES_REQUEST: null,
  GET_ALLOWED_COUNTRIES_SUCCESS: null,
}, 'SITE_CONFIG')

// ------------------------------------
// Actions
// ------------------------------------
export function languageChange(lang = 'en') {
  const language = lang.split(/[-_]/)[0].toLowerCase()
  setHtmlLangAndDir(language)
  return (dispatch) => {
    dispatch({
      type    : SITE_CONFIG.LANGUAGE_CHANGE,
      payload : language
    })
  }
}

function showFailedToast() {
  // 登陆失败，浮层提示保持以阻断用户操作
  Toast.info('Sorry, The verification information is expired. Please try again later.', 0)
}

export function getVerifyToken() {
  return (dispatch) => {
    return new Promise(resolve => {
      if (process.env.NODE_ENV === 'development') {
        // 测试用户：100000211616 971140252158413237 +971-585806138
        return resolve({
          codeVerifier: 'test',
          verifyToken: 'ecb78664a34348c28398c24d16464437',
        })
      }
      function onBridgeReady() {
        // Bridge方法注册成功
        console.log('ToPayJSBridge:start')
        try {
          // window.ToPayJSBridge.init 方法二次调用的时候会报错
          window.ToPayJSBridge.init(function(message, responseCallback) {})
        } catch (error) {}
        const random = Math.random().toString(16).slice(-8)
        window.ToPayJSBridge.invoke(
          'getVerifyToken',
          {
            codeChallenge: sha256(random),
            appDomain: window.location.hostname,
          },
          function(data) {
            if (data) {
              const res = JSON.parse(data)
              if (res && res.verifyToken) {
                return resolve({
                  codeVerifier: random,
                  verifyToken: res.verifyToken,
                })
              } else {
                showFailedToast()
              }
            } else {
              showFailedToast()
            }
          }
        )
      }
      console.log(typeof ToPayJSBridge)
      if (typeof ToPayJSBridge === 'undefined') {
        document.addEventListener('ToPayJSBridgeReady', onBridgeReady, false) // ToPayJSBridgeReady
      } else {
        onBridgeReady()
      }
    })
  }
}

var loginable = true // 并发的登陆请求，只允许一次，避免多次请求导致前面的token失效
export function login() {
  if (!loginable) {
    return
  }
  return (dispatch) => {
    Toast.loading('', 0)
    loginable = false
    return dispatch(getVerifyToken()).then((res) => {
      return dispatch(
        callAPI({
          dispatch: dispatch,
          endpoint: 'cgs/h5app/auth/v2/verify',
          body: {
            verifyToken: res.verifyToken,
            codeVerifier: res.codeVerifier,
          },
          method: 'POST',
          requestAction: SITE_CONFIG.DEFAULT_REQUEST,
          successAction: SITE_CONFIG.DEFAULT_SUCCESS,
          success: function(result) {
            Toast.hide()
            localStorage.setItem('user_id', result.userId)
            dispatch(replace(`${window.location.pathname}${window.location.search}`))
          },
          error: () => {
            showFailedToast()
          }
        })
      )
    })
  }
}

export function checkIsLogin(callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/common/checkLogon',
        requestAction: SITE_CONFIG.DEFAULT_REQUEST,
        successAction: SITE_CONFIG.DEFAULT_SUCCESS,
        success: function(result) {
          typeof callback === 'function' && callback()
        },
      })
    )
  }
}

export function getSalt() {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/common/getSalt',
        requestAction: SITE_CONFIG.GET_SALT_REQUEST,
        successAction: SITE_CONFIG.GET_SALT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getAppSalt(saltKey, callback) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          saltKey,
        },
        endpoint: 'cgs/common/getAppSalt',
        requestAction: SITE_CONFIG.GET_SALT_REQUEST,
        successAction: SITE_CONFIG.GET_SALT_SUCCESS,
        success: function(result) {
          dispatch({
            type: SITE_CONFIG.SAVE_SALT_KEY,
            payload: {
              saltKey,
            },
          })
          typeof callback === 'function' &&
            callback(Object.assign({ saltKey }, result))
        },
      })
    )
  }
}

export function removeSalt() {
  return (dispatch) => {
    dispatch({
      type: SITE_CONFIG.REMOVE_SALT,
    })
  }
}

export function queryIapConfig(token) {
  const OSName = new UAParser().getOS().name
  if (OSName === 'Android' || OSName === 'iOS') {
    return (dispatch) => {
      dispatch(
        callAPI({
          dispatch: dispatch,
          method: 'POST',
          body: {
            reqPlatform: OSName.toUpperCase(),
            token: token,
          },
          endpoint: 'cgs/cashdesk/u/queryIapConfig',
          requestAction: SITE_CONFIG.QUERY_IAPCONFIG_REQUEST,
          successAction: SITE_CONFIG.QUERY_IAPCONFIG_SUCCESS,
          success: function(result) {},
        })
      )
    }
  }
}

export function queryAgreements(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/common/contract/query',
        requestAction: SITE_CONFIG.QUERY_AGREEMENTS_REQUEST,
        successAction: SITE_CONFIG.QUERY_AGREEMENTS_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function queryNotice(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/notice/pull',
        requestAction: SITE_CONFIG.QUERY_NOTICE_REQUEST,
        successAction: SITE_CONFIG.QUERY_NOTICE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getCaptcha() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/personal/getCaptcha',
        requestAction: SITE_CONFIG.GET_CAPTCHA_REQUEST,
        successAction: SITE_CONFIG.GET_CAPTCHA_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getAllowedCountries(callback) {
  return (dispatch) => {
    const action = callAPI({
      dispatch,
      method: 'POST',
      endpoint: 'cgs/customerFrontend/listOpenCountry',
      requestAction: SITE_CONFIG.GET_ALLOWED_COUNTRIES_REQUEST,
      successAction: SITE_CONFIG.GET_ALLOWED_COUNTRIES_SUCCESS,
      success(result) {
        callback && callback()
      },
      error() {
        callback && callback(new Error('error'))
      }
    })
    dispatch(action)
  }
}

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
const ACTION_HANDLERS = {
  [SITE_CONFIG.LANGUAGE_CHANGE]: (state, action) =>
    Object.assign({}, state, { language: action.payload }),
  [SITE_CONFIG.DEFAULT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.DEFAULT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_SALT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_SALT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.REMOVE_SALT]: (state, action) =>
    Object.assign({}, state, { salt: undefined }),
  [SITE_CONFIG.SAVE_SALT_KEY]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_IAPCONFIG_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_IAPCONFIG_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_AGREEMENTS_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_AGREEMENTS_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_NOTICE_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_NOTICE_SUCCESS]: (state, action) =>
    Object.assign({}, state, { notices: action.payload.messages, isFetching: false }),
  [SITE_CONFIG.GET_CAPTCHA_REQUEST]: (state, action) => state,
  [SITE_CONFIG.GET_CAPTCHA_SUCCESS]: (state, action) =>
    Object.assign({}, state, { captcha: action.payload }),
  [SITE_CONFIG.GET_ALLOWED_COUNTRIES_REQUEST] : (state, action) =>
    Object.assign({}, state, {
      allowedCountries : {
        loading : true,
        list    : []
      }
    }),
  [SITE_CONFIG.GET_ALLOWED_COUNTRIES_SUCCESS] : (state, action) =>
    Object.assign({}, state, {
      allowedCountries : {
        loading : false,
        list    : action.payload
      }
    }),

}

// ------------------------------------
// Reducer and set default language
// ------------------------------------
const fallbackAllowedCountries = [
  {
    phonePrefix       : '+86',
    countryCode       : 'CN',
    countryFullName   : 'China',
    countrySimpleName : 'China',
    englishName       : 'China',
    icon              : ''
  },
  {
    phonePrefix       : '+971',
    countryCode       : 'AE',
    countryFullName   : 'United Arab Emirates',
    countrySimpleName : 'United Arab Emirates',
    englishName       : 'United Arab Emirates',
    icon              : ''
  }
]

const language = getCurrentLanguage()
setHtmlLangAndDir(language)
const initialState = {
  language: language,
  messages: messages,
  showHeader: true,
  allowedCountries : { loading: true, list: fallbackAllowedCountries },
}

function reducer(state = initialState, action = {}) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default {
  id: 'siteConfig',
  reducerMap: {
    siteConfig: reducer,
  },
  // Actions to fire when this module is added/removed
  initialActions : [getAllowedCountries()],
  middlewares    : [apiMiddleware],
  // finalActions: []
}
